import { useRef } from 'react'
import { useTranslation } from 'react-i18next'

import Stack from '@mui/material/Stack'
import TextField from '@mui/material/TextField'

import KNTooltipButton from 'components/KNTooltipButton/KNTooltipButton'
import type { KNTooltipButtonHandle } from 'components/KNTooltipButton/types'
import type KNClipboardFieldProps from './types'

const KNClipboardField: React.FC<KNClipboardFieldProps> = ({
                                                             value,
                                                             label,
                                                             size,
                                                             multiline,
                                                             rows,
                                                             loading,
                                                             onAction,
                                                             sx,
                                                           }) => {
  const { t } = useTranslation()
  const buttonRef = useRef<KNTooltipButtonHandle>(null)
  const handleCopy = async (): Promise<void> => {
    buttonRef.current?.showTooltip()
    await navigator.clipboard.writeText(value as string)
    onAction?.()
  }

  return (
    <Stack
      spacing={{ xs: 0.5, sm: 1 }}
      direction={{ xs: 'column', sm: 'row' }}
      alignItems={{ xs: 'start', sm: 'center' }}
      sx={sx}
    >
      <TextField
        label={label}
        value={value}
        size={size}
        multiline={multiline}
        rows={rows}
        fullWidth
        disabled={loading}
        slotProps={{
          input: {
            readOnly: true,
          },
        }}
      />
      <KNTooltipButton
        ref={buttonRef}
        tooltip={t('form.copied')}
        variant="contained"
        size="small"
        color="secondary"
        loading={loading}
        onClick={handleCopy}
      >
        {t('form.copy')}
      </KNTooltipButton>
    </Stack>
  )
}

export default KNClipboardField
